import { User } from "../../../components/shared/User/types";
import { changeAppState, getAppState } from "../../appState";

export function checkUser(): User | null {
    const { user } = getAppState();
    if (!user) {
        changeAppState("signInPanelState", {
            type: "signUp",
        });
        return null;
    }
    return user;
}

